/* @jsx h */
import { computed, defineComponent, h } from "vue";
import { useBranding } from "../providers/Branding";
import lemmonLogo from "@app/images/lemmon-logo-full.svg?raw";
import { useLocalization } from "@lemmonhq/uikit";

export const PublicFooterComponent = defineComponent({
  setup() {
    const { branding } = useBranding();
    const { t } = useLocalization();
    const isJavshani = computed(() => branding.value?.id === "javshani");

    return () => (
      <footer class="border-t border-gray-200 py-12 mt-20">
        <div class="max-w-7xl mx-auto px-4 text-center">
          <div class="mb-6">
            {isJavshani.value ? (
              <>
                <div class="text-2xl font-serif font-light text-gray-900 mb-2 uppercase">
                  {branding.value?.name}
                </div>
                <div class="text-xs text-gray-500 tracking-widest uppercase">
                  {branding.value?.subtitle}
                </div>
                <div class="mt-4 flex items-center justify-center gap-6">
                  {/* Plain anchor: /about is served by the worker, not the SPA router */}
                  <a href="/about" class="text-sm text-gray-600 underline">
                    {t("customer.home.about_us")}
                  </a>
                  <a
                    href="/javashani.pdf"
                    target="_blank"
                    rel="noopener"
                    class="text-sm text-gray-600 underline"
                  >
                    {t("customer.home.terms_and_conditions")}
                  </a>
                </div>
              </>
            ) : (
              <div class="flex flex-col items-center justify-center relative">
                <div class="text-2xl font-light text-gray-900 mb-2 uppercase">
                  {branding.value?.name}
                </div>
                <div class="text-xs text-gray-500 tracking-widest uppercase">
                  {branding.value?.subtitle}
                </div>
              </div>
            )}
          </div>
          <p class="text-gray-600 font-light mb-4 text-center mx-auto">
            {isJavshani.value
              ? t("customer.home.footer_javshani_tagline")
              : t("customer.home.footer_default_tagline")}
          </p>
          <p class="text-sm text-gray-500 text-center mx-auto">
            &copy; {new Date().getFullYear()}{" "}
            <span class="uppercase">{branding.value?.name}</span>.{" "}
            {t("customer.home.all_rights_reserved")}
          </p>
          <p class="text-sm text-gray-500 text-center mx-auto mt-2">
            <a
              target="_blank"
              href="https://lemmonpos.ch"
              rel="noopener"
              class="underline"
            >
              {t("customer.shop_shell.powered_by_lemmon")}
            </a>
          </p>
        </div>
      </footer>
    );
  },
});
